import React from 'react'

import { useAuth } from '@fourthwall/auth'
import { usePartnerDashboard } from '@hooks/usePartnerDashboard'
import { MenuDrawerProvider } from '@modules/Dashboard/contexts/MenuDrawerContext'
import { useFirstTimeVisit } from '@modules/Dashboard/hooks/useFirstTimeVisit'
import { useSaveVisit } from '@modules/Dashboard/hooks/useSaveVisit'

import { AIKitDashboardProvider } from '../AIKit/AIKitDashboardProvider'
import { DashboardView } from './DashboardView'
import { useAddProductToFavoritesModal } from './hooks/useAddProductToFavoritesModal'
import { useConnectedShopsQuery } from './hooks/useConnectedShopsQuery'
import { useCurrentShop } from './hooks/useCurrentShop'
import { LaunchStrategyProvider } from './modules/LaunchStrategy'
import { useOpenSubscriptionModal } from './modules/Subscriptions/hooks/useOpenSubscriptionModal'

export const DashboardContainer = () => {
  const { currentShop } = useCurrentShop()
  const { user } = useAuth()
  const { partnerDashboard } = usePartnerDashboard()
  const { connectedShopsQuery } = useConnectedShopsQuery()

  useFirstTimeVisit()
  useAddProductToFavoritesModal()
  useOpenSubscriptionModal()
  useSaveVisit()

  return (
    <MenuDrawerProvider>
      <LaunchStrategyProvider>
        <AIKitDashboardProvider>
          <DashboardView
            shopName={currentShop?.name}
            user={user ? { name: user.fullName, email: user.email } : undefined}
            connectedShops={connectedShopsQuery.data?.shops}
            partnerDashboard={partnerDashboard}
          />
        </AIKitDashboardProvider>
      </LaunchStrategyProvider>
    </MenuDrawerProvider>
  )
}
